module.exports = __webpack_public_path__ + "img/budget_tracker.c4cab607.png";